import { useAppDispatch } from "@/shared/hooks/appHooks";
import {
  ScreenNameType,
  setCurrentScreen,
} from "@motain/web-shared-hub/features";
import { useEffect } from "react";

export const useScreenName = (screenName: ScreenNameType): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCurrentScreen(screenName));
  }, [dispatch, screenName]);
};
